import { useContext } from 'react';

import { HistogramToolbarContext } from '../contexts/HistogramToolbar.context.js';

export const useHistogramToolbar = () => {
  const context = useContext(HistogramToolbarContext);
  if (context === undefined) {
    throw new Error(
      'useHistogramToolbar must be used within a HistogramToolbarContext',
    );
  }

  return context;
};
